import type { Result } from "@/lib/server/request";
import type {
  IListItem as IReviewListItem,
  ISubItem as ReviewSubItem,
} from "./sections/review-section/types";
import type { IServiceItem as SelectServiceItem } from "./sections/select-service-section/types";
import type { IProductItem as SelectProductItem } from "./sections/select-product-section/types";
import { CurrencyEnum } from "@/lib/types/currency.enum";

export type ISubItem = ReviewSubItem;
export type IServiceItem = SelectServiceItem;
export type IProductItem = SelectProductItem;

export type CurrencyCode = CurrencyEnum;

export type CartItem = IReviewListItem & {
  subItemIds: number[];
};
export type Values = {
  services: CartItem[];
  products: ISubItem[];
};
export type SubmitResponse = Result<void, Error>;
export type SubmitCallback = (values: Values) => Promise<SubmitResponse>;
export { CurrencyEnum };
